







































































































import Vue from 'vue'
import { Config } from '@/interfaces'

export default Vue.extend({
  name: 'ConfigurationForm',
  props: {
    config: {
      type: Object as () => Config,
      required: true,
    },
  },
  data: () => ({
    submitted: false,
    formData: {
      url: '',
      token: '',
      groups: '',
      projects: '',
    },
  }),
  watch: {
    config: function(config) {
      this.formData = { ...config }
    },
  },
  methods: {
    checkValidity() {
      const form = this.$refs.form as HTMLFormElement
      if (!this.formData.groups && !this.formData.projects) {
        return false
      }
      if (form) {
        return form.checkValidity()
      }
      return false
    },
    onSubmit(e: Event) {
      this.submitted = true
      this.$emit('onSubmit', this.formData)
    },
    onCancel() {
      this.$emit('onCancel')
    },
    validateInput(ref: string) {
      if (!this.submitted) {
        return null
      }
      const input = this.$refs[ref] as HTMLInputElement
      return (input && (input.value || this.submitted)) ? input.validity.valid && input.value : null
    },
    splitNames(names: string) {
      return names.split(';')
        .map((part) => part.trim())
        .filter((part) => part !== '')
    },
  },
  created() {
    this.formData = { ...this.config }
  },
})
